<template>
  <div class="attr-city-range">
    <el-select
      v-model="localValue"
      :placeholder="options.length ? '请选择(不选则对所有城市可见)' : '暂无规则'"
      :disabled="!options.length"
      clearable
      filterable
      no-data-text="暂无规则"
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="+item.rule_id"
        :label="item.rule_title"
        :value="+item.rule_id"
      />
    </el-select>

    <div v-if="localValue" class="city-collection" v-loading="cityLoading">
      <div class="city-collection__hd">
        <span class="city-collection__title">
          城市合集
          <em v-if="cityList.length">({{ cityList.length }})</em>
        </span>
        <el-button
          type="text"
          size="mini"
          icon="el-icon-download"
          :disabled="!cityList.length"
          @click="handleExport"
        >
          导出
        </el-button>
      </div>

      <div v-if="cityList.length" class="city-collection__body">
        <el-tag
          v-for="city in cityList"
          :key="city.city_code || city.city_name"
          size="mini"
          type="info"
          effect="plain"
        >
          {{ city.city_name }}
        </el-tag>
      </div>
      <div v-else-if="!cityLoading" class="city-collection__empty">
        暂无城市数据
      </div>
    </div>
  </div>
</template>

<script>
import { getDistributorShowRuleList, getDistributorShowRuleCities } from '@/api/shop'

export default {
  name: 'AttrCityRange',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localValue: this.value || '',
      options: [],
      cityList: [],
      cityLoading: false
    }
  },
  methods: {
    async getList() {
      try {
        const { template_douyin = 0 } = this.$route.query
        const res = await getDistributorShowRuleList({
          page: 1,
          page_size: -1,
          platform: template_douyin == 1 ? 'byte_mini' : 'wxapp'
        })
        this.options = res.data.data.list || []
      } catch (e) {
        this.options = []
      }
    },
    handleChange(val) {
      this.$emit('input', val)
      this.fetchCityList(val)
    },
    async fetchCityList(ruleId) {
      this.cityList = []
      if (!ruleId && ruleId !== 0) return

      this.cityLoading = true
      try {
        const res = await getDistributorShowRuleCities({ rule_id: ruleId })
        const cities = (res.data.data && res.data.data.cities) || []
        this.cityList = cities.filter(item => item.city_name)
      } catch (e) {
        this.cityList = []
      } finally {
        this.cityLoading = false
      }
    },
    handleExport() {
      if (!this.cityList.length) {
        this.$message.warning('暂无城市数据可导出')
        return
      }
      const rule = this.options.find(item => item.rule_id == this.localValue)
      const ruleTitle = rule ? rule.rule_title : this.localValue
      const names = this.cityList.map(item => item.city_name)
      const content = ['城市名称', ...names].join('\n')
      const blob = new Blob([`\ufeff${content}`], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `城市合集_${ruleTitle}_${Date.now()}.csv`
      link.click()
      URL.revokeObjectURL(url)
    }
  },
  watch: {
    value(val) {
      this.localValue = val
    },
    uuid: {
      handler() {
        this.localValue = this.value || ''
        this.fetchCityList(this.localValue)
      },
      immediate: true
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.attr-city-range {
  width: 100%;

  .el-select {
    width: 100%;
  }
}

.city-collection {
  margin-top: 10px;
  padding: 10px;
  background: #f7f8fa;
  border-radius: 4px;
  min-height: 60px;

  &__hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 12px;
    color: #606266;
    font-weight: 500;

    em {
      font-style: normal;
      color: #909399;
      margin-left: 2px;
    }
  }

  &__body {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-height: 160px;
    overflow-y: auto;
  }

  &__empty {
    font-size: 12px;
    color: #c0c4cc;
    line-height: 24px;
  }
}
</style>
